import React from 'react';
import {
    BooleanInput,
    DateTimeInput,
    Edit,
    FormTab,
    TabbedForm,
    TextInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

export const ThreadEdit = (props) => (
    <Edit {...props}>
        <TabbedForm>
            <FormTab label="Thread">
                <BooleanInput label="Closed?" source="closed" />
                <TextInput label="Link" source="link" />
                <TextInput label="Title" source="title" />
                <DateTimeInput label="Deleted" source="deleted_at" />
            </FormTab>
            <FormTab label="Message" path="message">
                <RichTextInput source="message" />
            </FormTab>
        </TabbedForm>
    </Edit>
)
